// ** Icons Import
import {Users, Database} from 'react-feather'


export default [
  // {
  //   header: 'Usuarios'
  // },
  {
    id: 'usuarios',
    title: 'Usuarios',
    icon: <Users size={20} />,
    navLink: '/usuarios/lista',
    rol:'Administrador'
  }
]